import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { ProductTopCtaComponent } from '../../../app/content/layout/components/product/product-top-cta/product-top-cta.component';
import { withCommonDecorators } from '../../_utils/story-helpers';
import { createDamilanoBarberaProduct, createLastBottlesProduct, createDiscountCountdownProduct } from '../../_mocks';
import type { WineProduct } from '../../../app/core/interfaces/generated/graphql';

function productWithTopCta(icon: string, text: string, type: string = 'text', overrides?: Partial<WineProduct>): any {
  return createDamilanoBarberaProduct({
    topCta: {
      __typename: 'TopCta',
      icon,
      text,
      type,
    },
    ...overrides,
  });
}

const meta: Meta<ProductTopCtaComponent> = {
  title: 'Molecules/Product/Product Top CTA',
  component: ProductTopCtaComponent,
  decorators: [...withCommonDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Top CTA banner on product cards showing countdown timer and promotional icons.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<ProductTopCtaComponent>;

export const WineBottleIcon: Story = {
  args: {
    product: productWithTopCta('CTA_WINE_BOTTLE', 'Kun i denne uge!'),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/kun i denne uge/i)).toBeInTheDocument();
  },
};

export const DiscountTagIcon: Story = {
  args: {
    product: productWithTopCta('CTA_DISCOUNT_TAG', 'Spar 25% – Tilbud slutter snart'),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/spar 25%/i)).toBeInTheDocument();
  },
};

export const NoIcon: Story = {
  args: {
    product: productWithTopCta('', 'Begrænset lager'),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/begrænset lager/i)).toBeInTheDocument();
  },
};

export const LastBottlesTopCta: Story = {
  args: {
    product: createLastBottlesProduct() as any,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/under 6 fl\. tilbage/i)).toBeInTheDocument();
  },
};

export const DiscountCountdown: Story = {
  args: {
    product: createDiscountCountdownProduct() as any,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-top-cta')).toBeTruthy();
  },
};

export const NoTopCta: Story = {
  args: {
    product: createDamilanoBarberaProduct() as any,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.top-cta')).toBeFalsy();
  },
};
